import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { CONTINUE_IDNOW_LINK } from './IDNowModal.actions';
import styles from './IDNowModal.module.css';
import messages from './IDNowModal.messages';
import { Dispatch } from 'redux';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    continueToIDNow: () => dispatch({ type: CONTINUE_IDNOW_LINK })
});

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

const IDNowModal = (props: PropsFromRedux) => {
    const { continueToIDNow } = props;

    return (
        <div className={styles.IDNowModal}>
            <div className={styles.title}>
                <FormattedMessage {...messages.title} />
            </div>
            <div className={styles.description}>
                <FormattedMessage {...messages.descriptionTop} tagName="p" />
                <FormattedMessage {...messages.descriptionBottom} tagName="p" />
            </div>
            <button
                className={styles.continueToIDNow}
                onClick={continueToIDNow}
            >
                <FormattedMessage {...messages.continueToIDNow} />
            </button>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(IDNowModal);
